import { graphql } from 'gql';

export const createContractGql = graphql(`
    mutation uerCreateContract(
        $fileContent: FileInput!
        $importOption: ContractImportEnum
        $projectUniqueId: String!
        $catalogUERBaseUniqueId: String
    ) {
        uerCreateContract(
            fileContent: $fileContent
            importOption: $importOption
            projectUniqueId: $projectUniqueId
            catalogUERBaseUniqueId: $catalogUERBaseUniqueId
        ) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateContractGql = graphql(`
    mutation uerUpdateContract(
        $id: Long!
        $name: String!
        $status: ContractStatusEnum!
        $subject: String!
        $internalNumber: String!
        $customer: String
        $customerAddress: String
        $contractor: String!
        $contractorAddress: String
        $account: String
        $signingDate: DateTime
        $startDate: DateTime
        $finishDate: DateTime
        $amountWithoutTax: Decimal
        $amountWithTax: Decimal
        $tax: Decimal
        $note: String
        $supplyBasis: String!
        $codeOKPD: String
        $codeOKUD: String
        $contractorOKPO: String
        $customerOKPO: String
        $documentUrl: String
        $priceParameters: ContractPriceParamsUpdateInput
        $remainder: Decimal
        $costRounding: Int!
    ) {
        uerUpdateContract(
            contractInput: {
                id: $id
                name: $name
                status: $status
                subject: $subject
                internalNumber: $internalNumber
                customer: $customer
                customerAddress: $customerAddress
                contractor: $contractor
                contractorAddress: $contractorAddress
                account: $account
                signingDate: $signingDate
                startDate: $startDate
                finishDate: $finishDate
                amountWithoutTax: $amountWithoutTax
                amountWithTax: $amountWithTax
                tax: $tax
                note: $note
                supplyBasis: $supplyBasis
                codeOKPD: $codeOKPD
                codeOKUD: $codeOKUD
                contractorOKPO: $contractorOKPO
                customerOKPO: $customerOKPO
                documentUrl: $documentUrl
                priceParameters: $priceParameters
                remainder: $remainder
                costRounding: $costRounding
            }
        ) {
            data {
                id
                signingDate
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const isUniqContractInternalNumberGql = graphql(`
    query uerIsUniqueContractInternalNumber($contractId: Long, $internalNumber: String!) {
        uerIsUniqueContractInternalNumber(contractId: $contractId, internalNumber: $internalNumber) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const setContractSeasonsGql = graphql(`
    mutation uerSetContractSeasons($contractId: Long!, $years: [Short!]!) {
        uerSetContractSeasons(contractId: $contractId, years: $years) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractObjectsGql = graphql(`
    query uerContractObjects(
        $constructionTypeId: Int
        $contractId: Long!
        $order: [ContractObjectDataSortInput!]
        $where: ContractObjectDataFilterInput
    ) {
        uerContractObjects(
            constructionTypeId: $constructionTypeId
            contractId: $contractId
            order: $order
            where: $where
        ) {
            constructionType {
                code
                id
                name
                shortName
                catalogId
                fullName
                contractFileName
                createdAt
            }
            hasWorkOrdersInProgress
            contractId
            fromVOR
            hasGuaranteedVolume
            id
            name
            parentId
            rationale
            rootObjectId
            status
            hasActsKC2
            codeWBS
        }
    }
`);

export const uerExportContractResultsGql = graphql(`
    query uerExportContractResults($contractId: Long!) {
        uerExportContractResults(contractId: $contractId) {
            actionRequired
            buttonText
            code
            data {
                count
                dataUrl
                name
                size
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerContractOtherCostLimitSpanSelectionListGql = graphql(`
    query uerContractOtherCostLimitSpanSelectionList($contractId: Long!, $otherCostId: Long) {
        uerContractOtherCostLimitSpanSelectionList(contractId: $contractId, otherCostId: $otherCostId) {
            actual
            constructionTypeId
            cost
            isSelected
            name
            otherCostTypeUniqueId
            plan
            reminder
            spanId
            spanType
            totalType
            spanSeasons {
                actual
                contractSeasonId
                plan
                reminder
                year
                cost
            }
        }
    }
`);

export const uerContractWorkOrdersGql = graphql(`
    query uerContractWorkOrders(
        $contractId: Long!
        $order: [ContractWorkOrderDataSortInput!]
        $where: ContractWorkOrderDataFilterInput
    ) {
        uerContractWorkOrders(contractId: $contractId, order: $order, where: $where) {
            hasActsKC2
            internalNumber
            signingDate
            status
            workOrderChange {
                id
                metadata
                name
                navLinkId
                signingDate
                status
                workOrderChangeNumber
                workOrderNumber
            }
            workOrderId
        }
    }
`);

export const getContractCatalogsGql = graphql(`
    query contractCatalogs($where: CatalogItemDataFilterInput) {
        catalogs(where: $where) {
            items {
                authoredBy
                createdAt
                id
                metadata
                name
                subsidiaryId
                subsidiaryName
                type {
                    allowMultiple
                    canCreate
                    methodologies
                    name
                    uniqueId
                }
                uniqueId
                updatedAt
            }
            totalCount
        }
    }
`);

export const uerCatalogsGql = graphql(`
    query uerCatalogs($where: CatalogItemDataFilterInput) {
        uerCatalogs(where: $where) {
            items {
                id
                name
                uniqueId
                authoredBy
                createdAt
                metadata
                subsidiaryId
                subsidiaryName
                type {
                    allowMultiple
                    canCreate
                    methodologies
                    name
                    uniqueId
                }
                updatedAt
            }
            totalCount
        }
    }
`);
